import { IonButton, IonCard, IonCardHeader, IonCardTitle, IonCol, IonContent, IonGrid, IonImg, IonPage, IonRow } from "@ionic/react";
import { FC, useEffect, useState } from "react";
import { useParams } from "react-router";
import { translation } from "../../models/translation";
import { fetchFeedsByTaxonomy, fetchFeedTaxonomy, fetchSingleFeed } from "../../services/feed_service";

const Feed: FC = () => {

    const { id } = useParams<{ id: string; }>();

    const siteText = translation();

    const [lan] = useState(siteText.lan);

    const [feed, setFeed] = useState<any>(null);
    const [relatedFeeds, setRelatedFeeds] = useState<any>(null);
    const [source,setSource]=useState<any>(null)

    useEffect(() => {
        fetchSingleFeed(id).then(
            m => {
                let relatedFeeds;
                fetchFeedsByTaxonomy(m.message.source).then(
                    n => relatedFeeds = n.message.filter((el: any) => el.id !== m.message.id).slice(0, 4)       
                )
                fetchFeedTaxonomy(m.message.source).then(
                    l => setSource(l.message)
                )
                setFeed(m.message);
                setRelatedFeeds(relatedFeeds)
            }
        )
    }, [id])

    const HeaderImage = () => {
        if (!feed._embedded) return (<></>);
        if (feed._embedded['wp:featuredmedia']) {
            return (
                <div>
                    <img alt="" className="ion-margin-top" src={feed._embedded['wp:featuredmedia'][0].source_url}></img>
                </div>
            )
        } else { return <></> }
    }


    return (
        <IonPage>
            <IonContent className="ion-padding" >
                <IonGrid>
                    {
                        !feed ? <></> :
                            <>
                                <IonRow>
                                    <IonCol sizeSm="8">
                                        <p>{source? `${siteText.feedsArticleSourceKey}:${source.name}` : ""}</p>

                                        <h1 dangerouslySetInnerHTML={{__html:feed.title.rendered}}></h1>
                                        <HeaderImage></HeaderImage>
                                        <div dangerouslySetInnerHTML={{ __html: feed.content.rendered }}>
                                        </div>
                                    </IonCol>
                                    <IonCol className="ion-padding">
                                        <h4 className="ion-margin-start">{siteText.feedsRelatedArticles}</h4>
                                        {
                                            !relatedFeeds ? <></> :
                                                relatedFeeds.map((relFeed: any) => {
                                                    return (
                                                        <IonCard routerLink={`${lan}/account/feeds/${relFeed.id}`} className="ion-margin-bottom" key={relFeed.id} >
                                                            <IonCardHeader>
                                                                {!relFeed._embedded['wp:featuredmedia'] ? <></> :
                                                                    <IonImg src={relFeed._embedded['wp:featuredmedia'][0].source_url}></IonImg>
                                                                }
                                                                <IonCardTitle>{relFeed.title.rendered}</IonCardTitle>
                                                            </IonCardHeader>
                                                        </IonCard>
                                                    )
                                                })
                                        }
                                        <IonButton className="ion-margin-start" fill="outline" routerLink={`${lan}/account/feeds`} >{siteText.feedsViewMore}</IonButton>
                                    </IonCol>
                                </IonRow>
                            </>
                    }

                </IonGrid>
            </IonContent>
        </IonPage >
    )

}

export default Feed;